module.exports = __webpack_public_path__ + "img/10_reinhard_ld25a15.42b80d74.png";